import {forwardRef} from "react";

import {RootDesc} from "@ui/descriptions/RootDesc";
import {BorderArticle} from "@ui/general/BorderArticle";
import {H3} from "@ui/titles/H3";
import {motion} from "framer-motion";

import styles from "./styles.module.scss";

const itemAnimation = {
  hidden: {transform: "scale(0.6)", opacity: 0},
  visible: (custom) => ({
    transform: "scale(1)",
    opacity: 1,
    transition: {
      delay: custom * 0.3,
    },
  }),
};

const CardItem = forwardRef(({key, icon, iconHover, subtitle, title}, ref) => {
  return (
    <li
      key={key}
      ref={ref}
    >
      <BorderArticle>
        <div className={styles.hero_card}>
          <i />

          <div className={styles.hero_card_icons}>
            <img
              src={icon}
              alt={"icon"}
            />
            <img
              src={iconHover}
              alt={"icon-hover"}
            />
          </div>

          <div className={styles.hero_card_content}>
            {title && <h4>{title}</h4>}

            <RootDesc>
              <span>{subtitle}</span>
            </RootDesc>
          </div>
        </div>
      </BorderArticle>
    </li>
  );
});

export const MCardItem = motion(CardItem);

export const HeroBlock = (props) => {
  const {description, cardsTitle, itemHover, cards} = props;

  return (
    <div className={styles.hero_block}>
      <div className={styles.hero_desc}>{description}</div>

      <div
        className={styles.hero_cards}
        style={{
          "--itemHover": itemHover,
        }}
      >
        {cardsTitle && (
          <div className={styles.hero_subtitle}>
            <H3>
              <span>{cardsTitle}</span>
            </H3>
          </div>
        )}

        <motion.ul
          initial={"hidden"}
          whileInView={"visible"}
          viewport={{amount: 0, once: true}}
        >
          {cards &&
            cards.length > 0 &&
            cards.map((card) => (
              <MCardItem
                custom={card.id + 1}
                variants={itemAnimation}
                key={card.id}
                icon={card.icon}
                iconHover={card.iconHover}
                subtitle={card.subtitle}
                title={card.title}
              />
            ))}
        </motion.ul>
      </div>
    </div>
  );
};
